import * as React from 'react'
import { Button, Card } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { PositionNumber, PositionNumberType } from 'api/common/constants'
import { PersonalGroupReferralCount } from 'api/common/types'
import { referrerGraphPersonalGroupListAPI } from 'api/referrerGraph'
import Footer from 'components/Footer'
import Header from 'components/Header'
import InputFieldConfirm from 'components/InputFieldConfirm'
import InputSelectField from 'components/InputSelectField'
import Pagination from 'components/Pagination'
import loginData from 'utilities/loginData'
import { ReferrerGraph, referrerGraphs, KeyValue, positions, getPositionLabel } from 'utilities/resources/options'
import { autoCast, numberFormat } from 'utilities/typeUtility'

type Params = {
  positionNumber: string
  atemQuestId: string
  pagination: string
}

/**
 * 紹介者管理パーソナルグループリスト
 */
const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const params = useParams<Params>()
  const positionNumber = autoCast<PositionNumberType>(params?.positionNumber ?? PositionNumber.MainPosition)
  const atemQuestId = params?.atemQuestId ?? ''
  const pagination = Number(params?.pagination ?? 0)
  const [selectablePositions, setSelectablePositions] = React.useState<KeyValue[]>([])
  const [positionNumberLabel, setPositionNumberLabel] = React.useState<string>()
  const [targetPositionId, setTargetPositionId] = React.useState<number>()
  const [targetAtemQuestId, setTargetAtemQuestId] = React.useState<string>()
  const [selectedAtemQuestId, setSelectedAtemQuestId] = React.useState<string>()
  const [PersonalGroupCountList, setPersonalGroupCountList] = React.useState<PersonalGroupReferralCount[]>([])
  const [maxCount, setMaxCount] = React.useState<number>(0)
  const changeGraph = (value: string) => {
    switch (value) {
      case ReferrerGraph.BinaryMap: {
        navigate(`/referrerManagementBinaryMap/${positionNumber}/0`)
        break
      }
      case ReferrerGraph.UniLevelList: {
        navigate(`/referrerManagementUniLevelList/${positionNumber}/0/1`)
        break
      }
    }
  }
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      setPositionNumberLabel(getPositionLabel(positionNumber))
      referrerGraphPersonalGroupListAPI(autoCast(positionNumber), atemQuestId, pagination, (response) => {
        if (response) {
          setSelectablePositions(positions.filter(({ key }) => response.selectablePositions.includes(autoCast(key))))
          setTargetPositionId(response.targetPositionId)
          setTargetAtemQuestId(response.targetAtemQuestId)
          setSelectedAtemQuestId(response.selectedAtemQuestId)
          setPersonalGroupCountList(response.referralCountList)
          setMaxCount(response.pageCount)
        }
      })
    }
  }, [navigate, positionNumber, atemQuestId, pagination])
  return (
    <>
      <Header title="紹介者管理" />
      <main>
        <section className="mx-4 my-5">
          <InputSelectField name="view-type" label="種別選択" items={referrerGraphs} bold setValue={changeGraph} value={ReferrerGraph.PersonalGroupList} />
          <InputSelectField
            name="position"
            label="ポジション選択"
            items={selectablePositions}
            bold
            setValue={(value) => navigate(`/referrerManagementPersonalGroupList/${value}/-/1`)}
          />
        </section>
        <section className="mx-4 my-5">
          <InputFieldConfirm label={`${positionNumberLabel}のコネクターID`} value={targetPositionId ?? '-'} bold />
          <InputFieldConfirm label="AUBEクエストID" value={targetAtemQuestId ?? '-'} bold />
          {targetAtemQuestId !== selectedAtemQuestId && <InputFieldConfirm label="選択中のAUBEクエストID" value={selectedAtemQuestId ?? '-'} bold />}
        </section>
        <section className="mx-4 my-5">
          <Card body className="border-0">
            {PersonalGroupCountList.length > 0 && (
              <>
                <div className="d-flex justify-content-between pb-1 border-bottom">
                  <div className="fw-bold note">AUBEクエストID</div>
                  <div className="fw-bold note" style={{ marginRight: '40px' }}>
                    紹介人数
                  </div>
                </div>
                {PersonalGroupCountList.map(({ atemQuestId, count }, index) => (
                  <button
                    className="w-100 d-flex py-3 bg-transparent border-0 border-bottom"
                    key={index}
                    onClick={() => navigate(`/referrerManagementPersonalGroupList/${positionNumber}/${atemQuestId}/1`)}
                  >
                    <div className="flex-fill text-start">{atemQuestId}</div>
                    <div>{numberFormat(count)}人</div>
                    <div className="fw-bold" style={{ width: '40px' }}>
                      &gt;
                    </div>
                  </button>
                ))}
              </>
            )}
            {PersonalGroupCountList.length === 0 && <div className="text-center">紹介はありません</div>}
            {targetAtemQuestId !== selectedAtemQuestId && (
              <>
                <div className="mt-5 text-center">
                  <Button variant="link" onClick={() => navigate(-1)}>
                    一つ前の表示に戻る
                  </Button>
                </div>
                <div className="mt-3 text-center">
                  <Button variant="link" onClick={() => navigate(`/referrerManagementPersonalGroupList/${positionNumber}/-/1`)}>
                    最初に戻る
                  </Button>
                </div>
              </>
            )}
            <Pagination
              className="mt-5"
              current={pagination}
              max={maxCount}
              limit={2}
              onClick={(page) => navigate(`/referrerManagementPersonalGroupList/${positionNumber}/${atemQuestId}/${page}`)}
            />
          </Card>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
